import { createRoutine, promisifyRoutine } from 'redux-saga-routines';
import { handleActions } from 'redux-actions';
import get from 'lodash/get';
import { RootState } from '../ts/types/store';
import FundingAmount from 'ts/models/FundingAmount.model';
import { createSelector } from 'reselect';

/** Prefixes */
export const CDF_UNIT_FUNDING_AMOUNT_PREFIX = 'CDF_UNIT_FUNDING_AMOUNT';

/** Actions */
export const FETCH_CDF_UNIT_FUNDING_AMOUNT = 'FETCH_CDF_UNIT_FUNDING_AMOUNT';
export const CREATE_CDF_UNIT_FUNDING_AMOUNT = 'CREATE_CDF_UNIT_FUNDING_AMOUNT';

/** Routines */
export const fetchCdfUnitFundingAmount = createRoutine(
  FETCH_CDF_UNIT_FUNDING_AMOUNT,
);
export const createCdfUnitFundingAmount = createRoutine(
  CREATE_CDF_UNIT_FUNDING_AMOUNT,
);

/** Promisified Routines */
export const createCdfUnitFundingAmountPromise = promisifyRoutine(
  createCdfUnitFundingAmount,
);
export const fetchCdfUnitFundingAmountPromise = promisifyRoutine(
  fetchCdfUnitFundingAmount,
);

/** Initial State */
type BlockTradesState = {
  count?: number;
  fundingAmounts?: FundingAmount[];
};

const initialState: BlockTradesState = {};

/** Reducer */
export default handleActions<BlockTradesState>(
  {
    [createCdfUnitFundingAmount.SUCCESS]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    [fetchCdfUnitFundingAmount.SUCCESS]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
  initialState,
);

/** Selectors */
export const getCdfUnitFundingAmountState = (
  state: RootState,
): BlockTradesState => get(state, 'cdfUnitFundingAmount', {});

export const getCars = createSelector([getCdfUnitFundingAmountState], (state) =>
  get(state, 'fundingAmounts', []),
);
